document.addEventListener("DOMContentLoaded", handleVideos);

function handleVideos() {
    const videos = document.querySelectorAll(".js-cloudinary-cont");
    if (videos.length === 0) return;

    createCloudinaryVideos(videos);
}

function createCloudinaryVideos(videos) {
    videos.forEach((video) => {
        createVideoPlayer(video);
    });
}

function createVideoPlayer(video) {
    const videoPlayer = document.createElement("video");
    const {
        dataset: { autoplay = false, url, hideControls },
    } = video;

    videoPlayer.src = url;
    videoPlayer.poster = url.replace(".mp4", ".webp");
    videoPlayer.classList.add("video-fluid");

    if (autoplay) {
        videoPlayer.autoplay = autoplay;
        videoPlayer.loop = autoplay;
        videoPlayer.muted = autoplay;
    }

    videoPlayer.controls = !hideControls;
    videoPlayer.setAttribute("playsinline", "");

    video.appendChild(videoPlayer);
}
